import { user } from '@features/user/data';

export const storesResolver = (): boolean => {
  return user.isLoggedIn;
};
